import React from 'react'
import {  Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Box, Button, Flex, Text } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { AppDispatch } from 'state'
import { useAllTransactions } from 'state/transactions/hooks'
import { useTranslation } from 'contexts/Localization'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { clearAllTransactions } from 'state/transactions/actions'
import { orderBy } from 'lodash'
import TransactionRow from './TransactionRow'

const ImageWrapper = styled.div`

${({ theme }) => theme.mediaQueries.md} {


}
`
const Divider = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundDisabled};
  height: 1px;
  margin: 16px auto;
  width: 100%;
`
const ButtonText = styled(Text)`
  display: none;
  ${({ theme }) => theme.mediaQueries.xs} {
    display: block;
  }
`

const WalletTransactions: React.FC = () => {
  const { chainId } = useActiveWeb3React()
  const dispatch = useDispatch<AppDispatch>()
  const { t } = useTranslation()
  const allTransactions = useAllTransactions()
  const sortedTransactions = orderBy(allTransactions, 'addedTime', 'desc')

  const handleClearAll = () => {
    if (chainId) {
      dispatch(clearAllTransactions({ chainId }))
    }
  }

  return (
    <Box minHeight="120px">
      <Flex alignItems="center" justifyContent="center" mb="15px">
        <Text color="primary" fontSize="15px" textTransform="uppercase" fontWeight="bold"  mr="10px">
          {t('Boosted Mining APR')}
        </Text>
        <ImageWrapper>
        <img src="/images/pixel/rocket.png" alt="ifo bunny" width="25px" height="25px"/>
      </ImageWrapper>
      </Flex >
      <Flex alignItems="center" justifyContent="space-between" mb="5px">
      <Flex alignItems="center" justifyContent="center" mb="5px">
      <ImageWrapper>
        <img src="/images/farms/3.png" alt="ifo bunny" width="28px" height="28px"/>
      </ImageWrapper>
        <Text color="text" fontSize="14px" textTransform="uppercase" fontWeight="bold"  ml="5px">
          {t('HVI-BNB')}
        </Text>
        <Text color="primary" fontSize="14px" textTransform="uppercase" fontWeight="bold"  ml="5px">
          {t('+7%')}
        </Text>
        </Flex >

        <Text color="text" fontSize="14px" textTransform="uppercase" fontWeight="bold"  ml="30px">
          {t('END: 2023-2-10 ')}
        </Text>
        </Flex >
      <Flex alignItems="center" justifyContent="space-between" mb="5px">
      <Flex alignItems="center" justifyContent="center" mb="5px">
      <ImageWrapper>
        <img src="/images/farms/4.png" alt="ifo bunny" width="28px" height="28px"/>
      </ImageWrapper>
        <Text color="text" fontSize="14px" textTransform="uppercase" fontWeight="bold"  ml="5px">
          {t('BVC-BNB')}
        </Text>
        <Text color="primary" fontSize="14px" textTransform="uppercase" fontWeight="bold"  ml="5px">
          {t('+15%')}
        </Text>
        </Flex >

        <Text color="text" fontSize="14px" textTransform="uppercase" fontWeight="bold"  ml="30px">
          {t('END: 2023-2-7 ')}
        </Text>
        </Flex >
        <Divider />
        <Flex alignItems="center" justifyContent="center" mt="15px">
        <Text color="primary" fontSize="14px"  bold >
        {t('Witch Minings, Pools or B2Mining will get boost?')}
        </Text>
      </Flex >
        <Flex alignItems="center" justifyContent="center" mt="10px">
        <Button as="a" width={80} height={35}  href="/voting/open" variant="secondary" >
        <ButtonText color="text" bold fontSize="16px">
          {t('VOTE')}
        </ButtonText>    
          </Button>
      </Flex >

     
    </Box>
  )
}

export default WalletTransactions
